module.exports = __webpack_public_path__ + "static/FrankensteinPromo-71-64bc8511bf60c70808ac4cd7af954294.jpg";